<template>
  <!--  <a-spin :spinning="isLoading">-->
  <div>
    <x-grid
        :id="'formList'"
        :rowId="rowId"
        :pager-config="pagerConfig"
        :form-config="formConfig"
        :url="url"
        :columns="columns"
        :checkbox-config="checkboxConfig"
        :toolbar-config="toolbarConfig"
        :print-config="printConfig"
        :import-config="importConfig"
        :export-config="exportConfig"
        :otherParams="{'actId':actId}"
        ref="grid"
    >
      <template v-slot:[toolbarConfig.templatelSlots]>
        <vxe-button @click="send">已兑奖</vxe-button>
      </template>
    </x-grid>

  </div>
  <!--  </a-spin>-->
</template>

<script>
import {
  GridMixin,
  api,
  fac,
} from "@/utils/common/XGridBase"
//列表接口
const url = api.market.ACT + '/searchJoinCondition';
import {dataApi} from "@/services/market/active";

//主键
const rowId = 'winId';

//列
const columns = [
  // fac.makeColumnRadioDefault(),
  fac.makeColumnCheckboxDefault(),
  fac.makeColumnSeqDefault(),
  fac.makeColumn("nickName", "参与人名称", 160, 'center'),
  fac.makeColumn("winDate", "参与时间", 160, 'center'),
  fac.makeColumn("cashingStatusName", "状态", 200, 'center'),
  fac.makeColumn("userName", "兑奖员工", 160, 'center'),
  fac.makeColumn("prizeName", "奖品名称", 160, 'center'),
  fac.makeColumn("name", "兑奖人员", 160, 'center'),
  fac.makeColumn("mobile", "兑奖手机号", 160, 'center'),
  fac.makeColumn("provinceName", "省", 100, 'center'),
  fac.makeColumn("cityName", "市", 100, 'center'),
  fac.makeColumn("districtName", "区", 100, 'center'),
  fac.makeColumn("address", "详细地址", 200, 'center'),
]

//筛选项
const formConfig = fac.makeFormConfig(columns, [
  {
    field: "cashingStatusName",
    type: "select",
    options: [
      {label: "未中奖", value: ""},
      {label: "未兑奖", value: '未兑奖'},
      {label: "已提交", value: '已提交'},
      {label: "已兑奖", value: '已兑奖'},
    ],
  },
  {field: "nickName"},
  {field: "prizeName"},
  {field: "userName"},
  {field: "name"},
  {field: "mobile"},
])

//工具栏按钮
const toolbarConfig = fac.makeToolbarConfig({
  import: false,
  export: true,
  delData: false,
  addData: false,
  templatelSlots: 'toolbarBtns'
});

//可编辑表格约束
const editRules = fac.makeEditRules(columns);
const printConfig = fac.makePrintConfig(columns);
const pagerConfig = fac.makePagerConfig();
const checkboxConfig = fac.makeCheckboxConfig(columns);

async function loadBaseData() {

}

export default {
  mixins: [GridMixin],
  props: ['actId'],
  data() {
    return {
      columns,
      rowId,
      url,
      exportUrl: api.market.ACT + '/exportExcelActivityWin?actId=' + this.actId+'&',
      formConfig,
      toolbarConfig,
      printConfig,
      checkboxConfig,
      editRules,
      pagerConfig,
    }
  },
  async mounted() {
  },
  methods: {
    loadBaseData,
    send() {
      let rows = this.$refs['grid'].$refs['xGrid'].getCheckboxRecords();
      if (rows.length === 0) {
        this.$message.error('请选择数据')
      } else {
        const parmas = rows.map(item => {
          return item.winId
        })
        dataApi.send(parmas).then(res => {
          if (res.code === 200) {
            this.$message.success('兑奖成功')
            this.refresh()
          }
        })
      }

    }
  }
}
</script>

<style scoped>
</style>
